export default __webpack_public_path__ + "static/media/pme-logo.a4409caf.png";